import React from 'react';

import { SVGComponentProps } from './svg.types';

const CheckBoxSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block  ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 7"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <rect x="0.5" y="0.5" width="7" height="7" rx="0.5" stroke="#55585E" fill={'none'} />
        <rect x="9" y="0" width="8" height="2" fill={fill} />
        <rect x="9" y="3" width="8" height="2" fill={fill} />
        <rect x="9" y="6" width="8" height="2" fill={fill} />
      </svg>
    </span>
  );
};

export default CheckBoxSVG;
